export const lookupTypes = {
    AdministrationTypes: 1,
    Correlators: 2,
    SourceTypes: 3,
    Genders: 4,
    SocialStatus: 5,
    BloodTypes: 6,
    HealthStatus: 7,
    ContractTypes: 8,
    IdentificationTypes: 10,
    AppointmentTypes: 11,
    HealthDiseaseTypes: 12,
    CourseTypes: 13,
    UserTypes: 14,
    AssignmentTypes: 15,
    TransferTypes: 16,
    TransferReasons: 17,
    NotificationsTypes: 18,
    ComplaintTypes: 19,
    TerminationTypes: 20,
    DelegatedTypes: 21,
    JobTypes: 23,
    RetirementTypes: 24,
    GrievanceType: 25,
    CorrectionTypes: 26,
    ProcedureTypes: 27,
};

export const status = {
    dataEnter: 10,
    active: 1,
    locked: 2,
    rejected: 4,
    approved: 5,
    expired: 11,
    replyed: 16
};



export const gender = {
    male: 1,
    female: 2
};
export const attachmentTypes = {
    PersonalPic: 1,
    PassportPic: 2,
    EmploymentPic: 3,
    StartingPic: 4,
    ChequePic: 5,
    HealthFile: 6,
    CourseFile: 7,
    QualificationFile: 8,
};
export const employeeStatus = {

    Alive: 1, // موظف دائم
    Deceased: 2, // متوفى
    Resigned: 3, // مُستقيل
    Dismissed: 4, // مَقال
    Retired: 6, // متقاعد
    transfered: 7,// منتقل
    unsafeHealth: 8,// عدم اليقة الصحية
    felony: 9,// الحكم عليه بجناية
};       